import axios from 'axios';

// Legacy localStorage keys from the pre-refresh-token auth system.
// The new system keeps the access token in Redux memory and relies on the
// httpOnly refresh cookie for persistence, so any leftover value here is
// stale and can put returning users into a logout loop until removed.
const LEGACY_AUTH_STORAGE_KEYS = ['token'];

const purgeLegacyAuthStorage = () => {
  try {
    LEGACY_AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    /* localStorage unavailable (private mode / SSR) — nothing to clean */
  }
};

const initializeApp = () => {
  purgeLegacyAuthStorage();

  // Setting base URL for all API request via axios
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

  // Note: 401 handling for axios is done in auth.js interceptors.
  //       401 handling for RTK Query (apiSlice) is done via baseQueryWithReauth
  //       which attempts a token refresh before redirecting to login.

  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
  } else {
    // Prod build code

    // Removing console.log from prod
    console.log = () => {};

    // init analytics here
  }
};

export default initializeApp;
